import React, { useCallback, useEffect, useState } from "react";
import { AdapterConfig } from "../../../../../domain/models/city-adapter-config";
import * as S from "../styles";

type Props = {
  config: AdapterConfig;
  onChange: (config: AdapterConfig) => void;
};

const JsonEditorSection: React.FC<Props> = ({ config, onChange }) => {
  const [jsonText, setJsonText] = useState(() => JSON.stringify(config, null, 2));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setJsonText(JSON.stringify(config, null, 2));
    setError(null);
  }, [config]);

  const handleChange = useCallback((value: string): void => {
    setJsonText(value);
    try {
      const parsed = JSON.parse(value);
      setError(null);
      onChange(parsed);
    } catch (e: any) {
      setError(e.message);
    }
  }, [onChange]);

  return (
    <S.SectionCard>
      <S.InfoBox>
        ℹ️ Modo avançado. Edite a configuração completa em formato JSON.
        A estrutura deve conter: <code>valoresFixos</code>, <code>deParaChaves</code>,{" "}
        <code>transformacoes</code> e <code>camposRemover</code>.
      </S.InfoBox>

      <textarea
        value={jsonText}
        onChange={(e) => handleChange(e.target.value)}
        style={{
          width: "100%",
          minHeight: 400,
          fontFamily: "monospace",
          fontSize: 12,
          lineHeight: 1.5,
          padding: 16,
          border: `2px solid ${error ? "#EB5757" : "rgba(255,255,255,0.1)"}`,
          borderRadius: 12,
          background: "#0E1428",
          color: "#91DBE4",
          resize: "vertical",
          outline: "none",
        }}
        spellCheck={false}
      />

      {error && (
        <p style={{ color: "#EB5757", fontSize: 12, marginTop: 8, fontFamily: "Poppins, sans-serif" }}>
          ❌ JSON inválido: {error}
        </p>
      )}
    </S.SectionCard>
  );
};

export default JsonEditorSection;
